// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-datepicker__header {
  background-color: transparent;
  border: none;
  padding: 0;
}

.react-datepicker__navigation--previous,
.react-datepicker__navigation--next {
  top: calc((44px - 32px) / 2);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.react-datepicker__navigation--previous {
  left: 12px;
}

.react-datepicker__navigation--next {
  right: 12px;
}

.react-datepicker__navigation--previous:hover,
.react-datepicker__navigation--next:hover {
  background-color: rgb(74, 162, 233, 0.2);
}

.react-datepicker__navigation-icon--next {
  top: 1px;
  left: 1px;
}

.react-datepicker__navigation-icon--previous {
  top: 1px;
  right: 1px;
}

.react-datepicker__navigation-icon--previous::before,
.react-datepicker__navigation-icon--next::before {
  border-color: #000000;
  border-width: 2px 2px 0 0;
}

.react-datepicker__navigation--previous:hover .react-datepicker__navigation-icon--previous::before,
.react-datepicker__navigation--next:hover .react-datepicker__navigation-icon--next::before {
  border-color: #000000;
}

.react-datepicker__day-names {
  display: flex;
  margin: 0;
}

.react-datepicker__day-name {
  width: 100%;
  margin: 2px;
  color: rgb(107, 114, 128);
  font-weight: 500;
  font-size: 14px;
}

.react-datepicker__header__dropdown {
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.react-datepicker {
  width: 384px;
  background-color: transparent;
  border: none;
  font-family: inherit;
}

.react-datepicker__month-container {
  width: 100%;
}

.react-datepicker__current-month {
  display: none;
}

.react-datepicker__month {
  margin: 0;
}

.react-datepicker__week {
  display: flex;
}

.react-datepicker__day {
  height: 40px;
  margin: 1px;
  border: 1px solid transparent;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  color: #000000;
  font-weight: 500;
  font-size: 14px;
}

.react-datepicker__day--today {
  border-color: #3DC1D3;
  color: #3DC1D3;
}

.react-datepicker__day--outside-month {
  color: rgb(209, 213, 219);
}

.react-datepicker__day:hover {
  border-color: rgb(37, 99, 235);
  color: rgb(37, 99, 235);
  background-color: transparent !important;
  border-radius: 14px !important;
}

.react-datepicker__day--selected {
  background-color: rgb(37, 99, 235);
  color: #ffffff;
  border-color: transparent;
}

.react-datepicker__day--selected:hover {
  background-color: rgb(37, 99, 235) !important;
  border-color: transparent;
  color: #ffffff;
}

.react-datepicker__day--disabled {
  color: rgb(209, 213, 219);
}

.react-datepicker__day--disabled:hover {
  color: rgb(209, 213, 219);
  border-color: transparent;
}

.react-datepicker__day--keyboard-selected {
  background-color: transparent;
}

.react-datepicker__month-select,
.react-datepicker__year-select {
  background-color: transparent;
  outline: none;
  appearance: none;
  font-size: 16px;
  font-weight: 500;
}

.react-datepicker__month-dropdown-container,
.react-datepicker__year-dropdown-container {
  margin: 0;
}

.react-datepicker__month-dropdown-container::after {
  content: '/';
  padding: 0 6px;
  font-size: 16px;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/styles/react-date-picker.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,YAAY;EACZ,UAAU;AACZ;;AAEA;;EAEE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,wCAAwC;EACxC,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".react-datepicker__header {\n  background-color: transparent;\n  border: none;\n  padding: 0;\n}\n\n.react-datepicker__navigation--previous,\n.react-datepicker__navigation--next {\n  top: calc((44px - 32px) / 2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n}\n\n.react-datepicker__navigation--previous {\n  left: 12px;\n}\n\n.react-datepicker__navigation--next {\n  right: 12px;\n}\n\n.react-datepicker__navigation--previous:hover,\n.react-datepicker__navigation--next:hover {\n  background-color: rgb(74, 162, 233, 0.2);\n}\n\n.react-datepicker__navigation-icon--next {\n  top: 1px;\n  left: 1px;\n}\n\n.react-datepicker__navigation-icon--previous {\n  top: 1px;\n  right: 1px;\n}\n\n.react-datepicker__navigation-icon--previous::before,\n.react-datepicker__navigation-icon--next::before {\n  border-color: #000000;\n  border-width: 2px 2px 0 0;\n}\n\n.react-datepicker__navigation--previous:hover .react-datepicker__navigation-icon--previous::before,\n.react-datepicker__navigation--next:hover .react-datepicker__navigation-icon--next::before {\n  border-color: #000000;\n}\n\n.react-datepicker__day-names {\n  display: flex;\n  margin: 0;\n}\n\n.react-datepicker__day-name {\n  width: 100%;\n  margin: 2px;\n  color: rgb(107, 114, 128);\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.react-datepicker__header__dropdown {\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.react-datepicker {\n  width: 384px;\n  background-color: transparent;\n  border: none;\n  font-family: inherit;\n}\n\n.react-datepicker__month-container {\n  width: 100%;\n}\n\n.react-datepicker__current-month {\n  display: none;\n}\n\n.react-datepicker__month {\n  margin: 0;\n}\n\n.react-datepicker__week {\n  display: flex;\n}\n\n.react-datepicker__day {\n  height: 40px;\n  margin: 1px;\n  border: 1px solid transparent;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 14px;\n  color: #000000;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.react-datepicker__day--today {\n  border-color: #3DC1D3;\n  color: #3DC1D3;\n}\n\n.react-datepicker__day--outside-month {\n  color: rgb(209, 213, 219);\n}\n\n.react-datepicker__day:hover {\n  border-color: rgb(37, 99, 235);\n  color: rgb(37, 99, 235);\n  background-color: transparent !important;\n  border-radius: 14px !important;\n}\n\n.react-datepicker__day--selected {\n  background-color: rgb(37, 99, 235);\n  color: #ffffff;\n  border-color: transparent;\n}\n\n.react-datepicker__day--selected:hover {\n  background-color: rgb(37, 99, 235) !important;\n  border-color: transparent;\n  color: #ffffff;\n}\n\n.react-datepicker__day--disabled {\n  color: rgb(209, 213, 219);\n}\n\n.react-datepicker__day--disabled:hover {\n  color: rgb(209, 213, 219);\n  border-color: transparent;\n}\n\n.react-datepicker__day--keyboard-selected {\n  background-color: transparent;\n}\n\n.react-datepicker__month-select,\n.react-datepicker__year-select {\n  background-color: transparent;\n  outline: none;\n  appearance: none;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.react-datepicker__month-dropdown-container,\n.react-datepicker__year-dropdown-container {\n  margin: 0;\n}\n\n.react-datepicker__month-dropdown-container::after {\n  content: '/';\n  padding: 0 6px;\n  font-size: 16px;\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
